const { resolveRequestSchema } = require('./resolveRequestSchema');

const NORMALIZING_ROUTES = new Set(['item.item', 'transaction.itemByTagId']);

/** The Serialized Each create handler normalizes EPC Tag URIs before storing canonical hex. */
function tagIdRequestSchema(requestSchema, schemas, { namespace, relation, tenantSettings, forValidation }) {
    if ((!forValidation && tenantSettings.addFromTagId !== true) || !NORMALIZING_ROUTES.has(`${namespace}.${relation}`)) {
        return requestSchema;
    }
    const schema = resolveRequestSchema(requestSchema, schemas);
    if (!schema.properties?.tagId) return requestSchema;
    const tagId = resolveRequestSchema(schema.properties.tagId, schemas);
    if (tagId.type !== 'string') return requestSchema;
    const annotations = Object.fromEntries(
        Object.entries(tagId).filter(
            ([key]) => ['title', 'description', 'default'].includes(key) || key.startsWith('x-')
        )
    );
    return {
        ...schema,
        properties: {
            ...schema.properties,
            tagId: {
                ...annotations,
                type: 'string',
                anyOf: [tagId, { type: 'string', pattern: '^\\s*urn:epc:tag:[^\\s]+\\s*$' }]
            }
        }
    };
}

module.exports = { tagIdRequestSchema };
